import {
  LayoutDashboard,
  Menu,
  ShoppingCart,
  Grid3x3,
  PackagePlus,
  ReceiptText,
  UserPlus,
  CreditCard,
  PartyPopper,
  Sparkles,
} from 'lucide-react';
import type { ComponentType } from 'react';

export type TourPlacement = 'center' | 'left' | 'right' | 'top' | 'bottom';

export type TourStep = {
  key: string;
  /** Route sur laquelle l'étape doit se jouer */
  route: string;
  /** Valeur de l'attribut data-tour à mettre en surbrillance (optionnel) */
  target?: string;
  placement: TourPlacement;
  icon: ComponentType<{ className?: string }>;
  title: string;
  body: string;
};

/**
 * Tour d'horizon « nouvel utilisateur » — actif uniquement sur les tenants démo
 * (is_demo). Explique le parcours Dashboard → Caisse en quelques étapes animées.
 */
export const DEMO_TOUR_STEPS: TourStep[] = [
  {
    key: 'welcome',
    route: '/dashboard',
    placement: 'center',
    icon: Sparkles,
    title: 'Bienvenue sur VisionPOS 👋',
    body: 'Découvrez l’essentiel de votre logiciel de caisse en moins d’une minute. Vous pourrez passer ou rejouer cette visite à tout moment.',
  },
  {
    key: 'dashboard',
    route: '/dashboard',
    target: 'dashboard',
    placement: 'center',
    icon: LayoutDashboard,
    title: 'Le tableau de bord',
    body: 'Votre chiffre d’affaires, le nombre de ventes du jour et vos raccourcis, en un coup d’œil dès la connexion.',
  },
  {
    key: 'menu',
    route: '/dashboard',
    target: 'sidebar',
    placement: 'left',
    icon: Menu,
    title: 'Le menu de navigation',
    body: 'Accédez à vos produits, clients, stocks, rapports et réglages depuis ce menu latéral.',
  },
  {
    key: 'open-caisse',
    route: '/caisse',
    placement: 'center',
    icon: ShoppingCart,
    title: 'La caisse',
    body: 'C’est ici que tout se passe : vous composez le panier et encaissez vos ventes.',
  },
  {
    key: 'categories',
    route: '/caisse',
    target: 'caisse-categories',
    placement: 'left',
    icon: Grid3x3,
    title: 'Vos catégories',
    body: 'Peintures, rouleaux, pinceaux, colorants… Touchez une catégorie pour filtrer instantanément vos articles.',
  },
  {
    key: 'products',
    route: '/caisse',
    target: 'caisse-products',
    placement: 'center',
    icon: PackagePlus,
    title: 'Ajouter au panier',
    body: 'Touchez un produit — ou scannez son code-barres — pour l’ajouter au panier. La photo et le prix s’affichent automatiquement.',
  },
  {
    key: 'cart',
    route: '/caisse',
    target: 'caisse-cart',
    placement: 'right',
    icon: ReceiptText,
    title: 'Le panier',
    body: 'Quantités, remises et total TTC se mettent à jour en direct. Vous gardez la main sur chaque ligne.',
  },
  {
    key: 'customer',
    route: '/caisse',
    target: 'caisse-customer',
    placement: 'right',
    icon: UserPlus,
    title: 'Client & fidélité',
    body: 'Rattachez un client à la vente pour cumuler des points, appliquer ses avantages et suivre son historique.',
  },
  {
    key: 'pay',
    route: '/caisse',
    target: 'caisse-pay',
    placement: 'right',
    icon: CreditCard,
    title: 'L’encaissement',
    body: 'Choisissez le moyen de paiement : le ticket s’imprime et la vente est enregistrée de façon sécurisée et conforme auto-cert.',
  },
  {
    key: 'end',
    route: '/caisse',
    placement: 'center',
    icon: PartyPopper,
    title: 'À vous de jouer ! 🎨',
    body: 'Vous connaissez l’essentiel.',
  },
];
